import Cookies from 'js-cookie'

if (!Cookies.get('oscuro')) {
  Cookies.set('oscuro', null)
}

if (Cookies.get('oscuro') === 'true') {
  document.getElementsByTagName('body')[0].classList.add('modo-oscuro')
}
